import React from 'react'
import qrGenerator_Img from './images/qr generate Img.png';

const Use_QRGenerate = () => {
    return (
        <section
            className="position-relative"
            style={{
                overflow: "hidden",
                marginTop: 60
            }}
        >
            <div
                className="mx-auto position-relative ws-wrap"
                style={{
                    maxWidth: "88%",
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    alignItems: "center",
                    gap: "40px"
                }}
            >
                {/* LEFT IMAGE */}
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <img
                        src={qrGenerator_Img}
                        alt="WhatsApp Link Generator"
                        style={{
                            width: "100%",
                            maxWidth: "480px",
                            height: "auto",
                            display: "block"
                        }}
                    />
                </div>

                {/* RIGHT CONTENT */}
                <div>
                    <h2
                        style={{
                            fontSize: "2.3rem",
                            fontFamily: "Inter",
                            fontWeight: 700,
                            color: "#242121ff",
                            lineHeight: 1.2,
                        }}
                    >
                        Why Use a WhatsApp Link Generator?
                    </h2>
                    <p
                        style={{
                            color: "#413e3eff",
                            fontSize: "1.1rem",
                            fontFamily: "Poppins",
                            fontWeight: 300,
                            lineHeight: 1.27,
                            marginBottom: "32px"
                        }}
                    >
                        A WhatsApp link generator can help you solve problems like missed opportunities,
                        lost sales, and disengaged contacts by enabling customers and prospects to
                        easily reach you.
                    </p>

                    {/* Bullet points */}
                    <div style={{ display: "flex", flexDirection: "column", gap: "22px" }}>
                        <div>
                            <h3
                                style={{
                                    fontSize: "1.3rem",
                                    fontWeight: 600,
                                    fontFamily: "Inter",
                                    color: "#0A2C54",
                                    marginBottom: "6px"
                                }}
                            >
                                Connect with People Instantly
                            </h3>
                            <p
                                style={{
                                    fontSize: "1.1rem",
                                    fontFamily: "Lato",
                                    fontWeight: 400,
                                    color: "#413e3eff",
                                    lineHeight: 1.25
                                }}
                            >
                                In just three easy steps, you can create a direct link enabling
                                individuals-who don’t have your contact details-to initiate a dialogue
                                on WhatsApp Business.
                            </p>
                        </div>

                        <div>
                            <h3
                                style={{
                                    fontSize: "1.3rem",
                                    fontWeight: 600,
                                    fontFamily: "Inter",
                                    color: "#0A2C54",
                                    marginBottom: "6px"
                                }}
                            >
                                Streamline Your Operational Workflows
                            </h3>
                            <p
                                style={{
                                    fontSize: "1.1rem",
                                    fontFamily: "Lato",
                                    fontWeight: 400,
                                    color: "#413e3eff",
                                    lineHeight: 1.25
                                }}
                            >
                                Level up your communication game, improve engagement, and enhance
                                customer experience by allowing customers and potential clients to
                                contact you instantly.
                            </p>
                        </div>

                        <div>
                            <h3
                                style={{
                                    fontSize: "1.3rem",
                                    fontWeight: 600,
                                    fontFamily: "Inter",
                                    color: "#0A2C54",
                                    marginBottom: "6px"
                                }}
                            >
                                Attain Maximum Revenue Potential
                            </h3>
                            <p
                                style={{
                                    fontSize: "1.1rem",
                                    fontFamily: "Lato",
                                    fontWeight: 400,
                                    color: "#413e3eff",
                                    lineHeight: 1.25
                                }}
                            >
                                Unlock revenue growth opportunities, elevate your sales, and amplify
                                your profit margins by tapping into the potential of personalised
                                WhatsApp business links.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Responsive styles */}
            <style>{`
                @media (max-width: 1024px){
                    .ws-wrap{
                        grid-template-columns: 1fr;
                        text-align: center;
                    }
                    .ws-wrap img{
                        margin: 0 auto 30px;
                    }
                }
            `}</style>
        </section>
    )
}

export default Use_QRGenerate
